module.exports = __webpack_public_path__ + "static/word-562a9870f2a5bcd92401beb6c0231d2a.jpg";